/* eslint-disable */
import axios from 'axios';

import {
	
} from './types'


export default {

    state : {
        _contragents : [],       
    },

   
    getters : {

        allContragents(state) {
            return state._contragents;
        },

        getContragentById: (state) => (id) => {
            return state._contragents.find(contragent => contragent.id === id)
          }

    },

    mutations: {


        deleteContragent(state, id) {
            const index =  state._contragents.findIndex(item => item.id === id);
            state._contragents.splice(index, 1);
        },

        retrieveContragent(state, data) {
            state._contragents = data;
        },

        saveContragent(state, data) {
            const index =  state._contragents.findIndex(item => item.id === data.id);
            if (index == -1) state._contragents.push(data);
            else state._contragents.splice(index, 1, data);
        }


    },

    actions : {
        lockContragent(context, id) {
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                    
                axios.post('/contragent/lock/' + id, {id:id})
                .then(response => {
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'saveContragent', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },

        unlockContragent(context, id) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                
                axios.post('/contragent/unlock/' + id, {id:id})
                .then(response => {
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'saveContragent', 'content' : response.data});
                    // context.rootState.ds.event.emit('saveContragent', response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },


        deleteContragent(context, data) {
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.delete('/contragent/'+data.id)
                .then(response => {
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'deleteContragent', 'content' : data.id});
                    // context.rootState.ds.event.emit('deleteContragent', data.id);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },

        saveContragent(context, data) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/contragent/'+data.id, data)
                .then(response => {
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'saveContragent', 'content' : response.data});
                    // context.rootState.ds.event.emit('saveContragent', response.data);
                    resolve(response.data);

                })
                .catch(error => {
                    reject(error)
                });
            });

        },

        retrieveContragents({dispatch, commit, rootState}) {
            
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

                axios.get('/contragent')
                    .then(response => {
                        commit('retrieveContragent', response.data)       
                        resolve(true);          
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        }
                        else {
                            console.log(error);
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{        // повторная загрузка через секунду
                                dispatch('retrieveContragents');
                            }, t);
                            reject(error.response.status)
                        }
                    });
            });
        },
    }

}